import React, { useState } from "react";
import style from "./rule.module.css";
import Modal from "../../components/modal/Modal";
import Header from "../../components/header/Header";

interface ruleProp {
  onClose: () => void;
  isModal: boolean;
}
export const RuleTab = function () {
  return (
    <ul className={`${style.items}`}>
      <li>
        دعوت از دوست می‌بایست حتما از طریق اشتراک‌گذاری لینک دعوت و شرکت آگاهانه
        فرد دعوت شده در بازی بانی‌مد صورت بگیرد.
      </li>
      <li>
        در صورت لغو سفارشی که در آن از کد تخفیف حاصل از بازی استفاده شده، امکان
        فعال‌سازی مجدد کد تخفیف وجود نخواهد داشت.
      </li>
      <li>
        سفارشات ثبت شده با کد تخفیف 100% بازی غیرقابل مرجوع یا تعویض هستند.
      </li>
      <li>کدهای تخفیف منقضی‌شده بازی قابل تمدید نیستند.</li>
      <li>
        برخورداری از خدمات، جوایز و تخفیفات بازی گردونه بانی‌شانس منوط به رعایت
        قوانین بازی است و هر زمان بانی‌مد با صلاحدید خود، تخلف یا سواستفاده از
        سمت کاربر را تشخیص دهد، راسا مجاز به حذف امتیازات دریافتی، لغو سفارش‌های
        ثبت‌شده و یا برخورد قانونی با فرد خاطی است.
      </li>
    </ul>
  );
};
export const GuideTab = function () {
  return (
    <ul className={`${style.items} fade-in-1`}>
      <li>
        کدهای تخفیف دریافتی در گردونه جوایز ویژه بازی تنها کدهایی هستند که امکان
        استفاده همزمان با اکثر جوایز دریافتی از سایر گردونه‌های بازی را دارا
        هستند.
      </li>
      <li>جوایز دریافتی از بازی نهایتا بعد از 3 روز منقضی خواهند شد.</li>
      <li>
        با دعوت از هر دوست بانی‌مدی به بازی 2 شانس بازی و 2 شانس ویژه دریافت
        خواهید کرد.
      </li>
      <li>
        با دعوت از هر دوست غیربانی‌مدی به بازی 5 شانس بازی و 5 شانس ویژه دریافت
        خواهید کرد.
      </li>
      <li>دوست بانی‌مدی کسی است که قبلا به عضویت سایت بانی‌مد درآمده است.</li>
      <li>
        دوست غیربانی‌مدی کسی است که قبلا به عضویت سایت بانی‌مد درنیامده و از
        طریق لینک دعوت شما به خانواده بانی‌مد خواهد پیوست.
      </li>
    </ul>
  );
};
const RuleModal: React.FC<ruleProp> = ({ onClose, isModal }) => {
  const [tab, setTab] = useState<"rule" | "guide">("rule");
  return (
    <Modal
      className={style["rule-modal"]}
      onClose={onClose}
      animation="slide-left"
      isModal={isModal}
    >
      <div className={`${style.rule}`}>
        <Header
          onBack={onClose}
          title="راهنما و قوانین بازی"
          className={style.hedaer}
        />
        <div className={style.inner}>
          <div className={style.tabs}>
            <button
              onClick={() => setTab("rule")}
              className={`${style.tab} ${
                tab === "rule" ? style["tab-active"] : ""
              }`}
            >
              قوانین بازی
            </button>
            <button
              onClick={() => setTab("guide")}
              className={`${style.tab} ${
                tab === "guide" ? style["tab-active"] : ""
              }`}
            >
              راهنمای بازی
            </button>
          </div>

          {tab === "rule" && <RuleTab />}
          {tab === "guide" && <GuideTab />}
        </div>
      </div>
    </Modal>
  );
};

export default RuleModal;
